import {QPost} from "./common/pfetch";
import { h } from 'preact';
import {getCitySpecificCategoryId} from "./common/cityChangeHelper";
import getPageType from 'rum-pagetypes/src';
import Cookies from 'universal-cookie';

const escrowCategoriesMap = {
    'home-lifestyle': 40,
    'electronics-appliances': 247,
    'mobiles-tablets': 269
};

const logoHref = '/bazaar';

const searchCityCallbackForCategory = (cityId, cityName, globalId, match) => {
    cityId = cityId*1;
    cityName = cityName.toLowerCase();
    const isAllIndia = (cityId === 0 || cityId === 1);
    const pageUrl = match.url;
    const matches = pageUrl.match(/[gId|cId](\d+)/);
    const gIdMatches = pageUrl.match(/gId(\d+)/);
    const gId = (gIdMatches && gIdMatches.length)?1*gIdMatches[1]:0;
    const catId = gId?0:1*matches[1];

    getCitySpecificCategoryId(cityId, gId, catId).then((categoryId) => {
        let slugParams = match.params.slug.split('+');
        let slugParamsLength = slugParams.length;
        if(isAllIndia){
            if(slugParamsLength === 1){
                slugParams[0] = 'gId'+escrowCategoriesMap[match.params.type];
            }else{
                slugParams[slugParamsLength - 2] = 'gId'+escrowCategoriesMap[match.params.type];
                slugParams.splice(slugParamsLength - 1, 1);
            }
        }else{
            if(slugParamsLength === 1){
                slugParams[0] = cityName;
                slugParams[1] = 'cId'+categoryId;
            }else{
                slugParams[slugParamsLength - 2] = cityName;
                slugParams[slugParamsLength - 1] = 'cId'+categoryId;
            }
        }
        window.location.href = window.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + window.location.search;
    }).catch((err) => {
        console.log(err);
    });
};

const searchCityCallbackForSnb = (cityId, cityName, globalId, match) => {
    cityId = cityId*1;
    const isAllIndia = (cityId === 0 || cityId === 1);
    const pageUrl = match.url;
    const matches = pageUrl.match(/[w|x|y|z](\d+)([a-zA-Z]+)/);
    const gIdMatches = pageUrl.match(/[y|z](\d+)([a-zA-Z]+)/);
    const gId = (gIdMatches && gIdMatches.length)?1*gIdMatches[1]:0;
    const catId = gId?0:1*matches[1];

    getCitySpecificCategoryId(cityId, gId, catId).then((categoryId) => {
        let searchMatches = pageUrl.match(/(x|z)(\d+)/);
        let isSearchUrl = (searchMatches && searchMatches.length);
        let slugParams = match.params.slug.split('+');
        let slugParamsLength = slugParams.length;
        if(isAllIndia){
            slugParams[slugParamsLength - 1] = (isSearchUrl?'z':'y')+categoryId+matches[2];
            slugParams[slugParamsLength - 2] = 'India';
        }else{
            slugParams[slugParamsLength - 1] = (isSearchUrl?'x':'w')+categoryId+matches[2];
            slugParams[slugParamsLength - 2] = cityName;
        }
        window.location.href = window.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + window.location.search;
    }).catch((err) => {
        console.log(err);
    });
};

const searchCityCallbackForCertified = (cityId, cityName, globalId, match) => {
    cityId = cityId*1;
    const isAllIndia = (cityId === 0 || cityId === 1);

    let slugParams = match.params.slug.split('+');
    const slugParamsLength = slugParams.length;
    if(slugParamsLength){
        if(isAllIndia){
            if(slugParamsLength > 1){
                slugParams.splice(slugParamsLength - 1, 1);
            }
        }else{
            if(slugParamsLength > 1){
                slugParams[slugParamsLength - 1] = cityName.toLowerCase();
            }else{
                slugParams[slugParamsLength] = cityName.toLowerCase();
            }
        }
    }
    window.location.href = window.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + window.location.search;
};

const searchCityCallbackForAssured = (cityId, cityName, globalId, match) => {
    cityId = cityId*1;
    const isAllIndia = (cityId === 0 || cityId === 1);

    let slugParams = match.params.slug.split('+');
    const slugParamsLength = slugParams.length;
    if(slugParamsLength){
        if(isAllIndia){
            if(slugParamsLength > 1){
                slugParams.splice(slugParamsLength - 1, 1);
            }
        }else{
            if(slugParamsLength > 1){
                slugParams[slugParamsLength - 1] = cityName.toLowerCase();
            }else{
                slugParams[slugParamsLength] = cityName.toLowerCase();
            }
        }
    }
    window.location.href = window.location.origin + '/' + slugParams.join('+') + window.location.search;
};

const searchCityCallbackForBazaar = (cityId, cityName, globalId, match) => {
    window.location.reload();
};

const qgAssuredSearchUI = (text,callbackfun)=>{
    return ( <div class="qg_assured-search" onclick={callbackfun} style="background-color: #fff;color: #333;display: flex;align-items: center;border-bottom: 1px solid rgb(220, 220, 220);padding: 0.8125rem 0.9375rem;">
        <svg viewBox="0 0 162.5 180.9" fill="#17AA4A" style="width: 1.5rem;margin-right: 0.5rem;" >
            <path opacity="0.15" fill="#17AA4A" d="M91.2,171c-3.5,1.5-7.1,2.8-10.9,4C-6.8,145.4,4.9,57.1,7,44.7L81.6,6.3l8.7,4.6L15.8,50.2 C15.8,50.2,0.1,141.5,91.2,171z"></path><path fill="17AA4A" d="M161,43.6C161,43.5,161,43.5,161,43.6l-0.2-1.4L82.3,0.4L81.7,0L81,0.4L2,40.9l-0.2,1.3 C1.5,43.3-18,147.8,79,180.5l1.3,0.4l1.3-0.4c20.3-6.5,37.2-16.8,50.1-30.4c3.2-3.4,6.1-7,8.8-10.7c7.5-10.5,13.1-22.5,16.8-35.8 C165.9,72.8,161.4,45.7,161,43.6z M152,102c-4.8,17.3-13,32.2-24.3,44.2c-6,6.3-12.8,11.9-20.5,16.6c-3.5,2.1-7.1,4.1-11,5.9l0,0 c-1.6,0.8-3.3,1.5-4.9,2.2c-3.5,1.5-7.2,2.8-10.9,4C-6.8,145.4,4.9,57.1,7,44.7L81.6,6.3l8.7,4.6l65.3,34.8 C156.5,51.6,159.3,75.7,152,102z M104.9,122.5l17.2,0.1l-3.6,16.5L99.2,139c-5.4,0-12.7-0.9-17-8.4l-6.5-11.3 c-2.6-4.1-2.4-4.9-7-5.2c-5.1-0.3-10.8-1-14-2.2c-7.8-3.1-14.1-9-14.9-19.6c-0.2-2.7-0.1-5.5,0.2-8.5c0.4-3.4,1.3-7.4,2.1-10.7 c2.3-8.9,5.3-16,10.9-21.3c7.1-6.8,17.1-9.4,26.6-9.6c3.7-0.1,10.2,0.1,15.5,0.9c11.7,1.7,20.4,8.6,21.4,21.1c1,12-3.9,32-13,40.6 c-2,1.9-4.3,3.5-6.8,4.8l-4.5-7.9c-1.8-3-3.5-4.9-5.3-6.1c2.9-1.8,4.9-4.5,6.6-8.2c1.9-4.3,4.5-14.5,3.9-19.3 c-0.5-5.3-4-9.5-12.4-10.1c-3.7-0.2-7.5,0-11,0.9c-3.2,0.8-5.9,2.2-7.8,4c-4.5,4.2-7.5,14.9-8,21c-0.3,4.2,0.3,7.5,1.8,9.7 c2.7,4,6.9,4.4,11.2,4.4h3.2c5.1,0,9.4,0.6,13.7,8.1l5.5,9.7C96.7,120.9,97.3,122.4,104.9,122.5z"></path>
        </svg>
        {text}
    </div> )
}

const qgAssuredCallbackFunc = ()=>{
    if(typeof window.gdGlobalFunForAssuredSearch ==='function'){
        gdGlobalFunForAssuredSearch();
    }
};

const customSearchForBazaar = ()=>{
    let _ui = qgAssuredSearchUI('Quikr Assured Products',qgAssuredCallbackFunc);
    return _ui ;
};

const customSearchForCategory = ()=>{
    let _path = location.pathname.split('/')[1];
    let text = '';
    if((_path === 'home-lifestyle' && (location.search == '?filter=fd' || location.search =='?filter=hl')) || _path === 'electronics-appliances'){

        if(_path === 'home-lifestyle'){
            text = 'Explore Quikr Assured Furniture';
        }
        else if(_path === 'electronics-appliances'){
            text = 'Explore Quikr Assured Electronics';
        }

        let _ui = qgAssuredSearchUI(text,qgAssuredCallbackFunc);
        return _ui ;
    }
};

const vapBack = (e, history, match)=>{
    let _backURL = window.vapCustomBackURL ? window.vapCustomBackURL : '/bazaar';
    if('referrer' in document){
        let referrer = document.referrer;
        let isQuikrUrl = referrer ? referrer.search(/\.quikr.com\//) : -1;

        if(isQuikrUrl!==-1) {
            history.goBack();
        }
        else {
            location.href = _backURL;
        }
    }
    else {
        location.href = _backURL
    }
};

function getJKID() {
    const cookies = new Cookies();
    const jkidCookie = cookies.get('_jk_id') && cookies.get('_jk_id').split('.');
    return jkidCookie && jkidCookie[0];
}

function getCurrentCityId() {
    const cookies = new Cookies();
    const cityCookie = cookies.get('prefer_city_id') || '1';
    return cityCookie;
}

const exampleConfig = [
    {
        route: {path:'/bazaar/bazaar-experience-zones', exact: true},
        header: {
            show: false,
            hasLogo: false,
            back:false,
            toolbarItems: false,
            hasTitle: false,
            hamburger:false,
            CustomTitle :() => <span>Quikr Experience Zone</span>
        },
        pageType: 'warehouse',
        footer: {show: false},

        qrum: (location, match) => {
            const city = getCurrentCityId();
            const config = { PTYPE: getPageType('GOODS_WAREHOUSE_PWA'), CITY: city, JKID: getJKID() };
            return config;
        }
    },
    {
        route: {path:'/bazaar/exchange-old-for-new-through-quikr', exact: true},
        header: {show: false},
        footer: {show: false}
    },
    {
        route: { path:'/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*[cId|gId][\\d]+)',exact: true }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
        header: {
            show: true,
            hasTitle: true,
            logoHref: logoHref,
            searchCityCallback: searchCityCallbackForCategory,
            marketTalkButton: true
        },
        pageType: 'category',
        search: { show: true, placeholder: 'Please enter keyword', searchSuggestions:customSearchForCategory, showDefaultSuggestion:true },
        footer: { show: true },
        ga: {trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7'},
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.type;

            }
            const city = getCurrentCityId();
            const config = { PTYPE: getPageType('GOODS_CATEGORY_PWA'), CAT: category, CITY: city, JKID: getJKID() };
            return config;
        }
    },
    {
        route: { path:'/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*[w|x|y|z][\\d]+f.*)',exact: true }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
        header: {
            show: true,
            hasTitle: true,
            logoHref: logoHref,
            searchCityCallback: searchCityCallbackForSnb,
            category: 'goods',
            gaPageType: 'SnB',
            viewinAppFAB: true,
            qkrAppWidget: true,
            marketTalkButton: true
        },
        pageType: 'Snb',
        search: { show: true, placeholder: 'Please enter keyword' },
        footer: { show: true },
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                category = match && match.params && match.params.type;
            }
            const city = getCurrentCityId();
            const config = { PTYPE: getPageType('GOODS_SNB_PWA'), CAT: category, CITY: city, JKID: getJKID() };
            return config;
        },
        ga: {trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7'},
    },
    {
        route: { path: '/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*W0QQAdIdZ[\\d]+)',exact: true },
        header: {
            show: true,
            hasTitle: false,
            logoHref: logoHref,
            hamburger:false,
            back:true,
            toolbarItems: false,
            handleBackClick:vapBack,
            walletIcon: true
        },
        pageType: 'VAP',
        search: { show: false },
        footer: { show: true },
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                //console.log(match.params,1);
                category = match && match.params && match.params.type;
            }
            const city = getCurrentCityId();
            const config = { PTYPE: getPageType('GOODS_VAP_PWA'), CAT: category, CITY: city, JKID: getJKID() };
            return config;
        },
        ga: {trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7'},
    },
    {
        route: { 
            path:'/:type(bazaar|electronics-appliances)/:slug([certified-refurbished-products|refurbished-electronics].*)',
            exact: true
        },
        header: {
            show: true,
            hasTitle: true,
            logoHref: logoHref,
            marketTalkButton: true,
            searchCityCallback: searchCityCallbackForCertified
        },
        pageType: 'certified',
        search: { show: true, placeholder: 'Please enter keyword' },
        footer: { show: true },
        qrum: (location, match) => {
            let category = 'NA';
            if (typeof match !== 'undefined') {
                //console.log(match.params,1);
                category = match && match.params && match.params.type;
            }
            const city = getCurrentCityId();
            const config = { PTYPE: getPageType('GOODS_CERTIFIED_PWA'), CAT: category, CITY: city, JKID: getJKID() };
            return config;
        },
        ga: {trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7'},
    },
    {
        route: { path:'/:slug(quikr-assured-products.*)',exact: true },
        header: {
            show: true,
            hasTitle: true,
            searchCityCallback: searchCityCallbackForAssured
        },
        pageType: 'certified',
        search: { show: true, placeholder: 'Please enter keyword' },
        footer: { show: true },
        qrum: (location, match) => {
            const city = getCurrentCityId();
            const config = { PTYPE: getPageType('COMMON_ASSURED_PWA'), CITY: city, JKID: getJKID() };
            return config;
        },
        ga: {trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7'},
    },
    {
        route: {
            path: '/:type(bazaar)',
            exact: true
        }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
        header: {
            show: true,
            hasTitle: true,
            logoHref: logoHref,
            marketTalkButton: true,
            searchCityCallback: searchCityCallbackForBazaar
        },
        pageType: 'bazaar',
        search: { show: true, placeholder: 'Please enter keyword',searchSuggestions:customSearchForBazaar,showDefaultSuggestion:true },
        footer: { show: true },
        qrum: (location, match) => {
            const city = getCurrentCityId();
            const config = { PTYPE: getPageType('GOODS_BAZAAR_PWA'), CITY: city, JKID: getJKID() };
            console.log(config,123);
            return config;
        },
        ga: {trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7'},
    },
    {
        route: {
            path: '/:type(bazaar|escrow)',
            exact: false,
          }, // Refer https://reacttraining.com/react-router/web/api/Route/path-string.
        header: { show: true, logoHref: logoHref, marketTalkButton: true },
        search: { show: true, placeholder: 'Please enter keyword' },
        footer: { show: true },
        qrum: (location, match) => {
            const city = getCurrentCityId();
            const config = { PTYPE: getPageType('GOODS_BAZAAR_PWA'), CITY: city, JKID: getJKID() };
            return config;
        },
        ga: {trackerName: 'quikrGoodsPWAtracker', accountId: 'UA-5568615-7'},
    }
];

export default exampleConfig;


// WEBPACK FOOTER //
// ../q-goods/src/shellConfig.js